import { SIQFAQBottomBarTheme } from "./SIQFAQBottomBarTheme";
export class SIQArticleTheme {
  Toolbar = new SIQFAQBottomBarTheme();
}
//# sourceMappingURL=SIQArticleTheme.js.map